import { render, staticRenderFns } from "./EditProfileInfo.vue?vue&type=template&id=ba410ce4&"
import script from "./EditProfileInfo.vue?vue&type=script&lang=js&"
export * from "./EditProfileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports